import {
  GET_CHANNEL_INFO, UPDATE_CHANNEL_INFO, CREATE_INTERFACE_INFO, SAVE_EXTRACTION_INFO,
  SAVE_PORT_SETUPS, SAVE_REFERENCE_NETS, UPDATE_SIGNAL_NAME, UPDATE_SIGNAL_NETS, UPDATE_STATUS, UPDATE_LOADING,
  DELETE_SIGNAL_NET, ADD_SIGNAL_NET, CONFIG_OPERATION, EDIT_COMPONENT_PIN_TABLE,
  SAVE_PIN_MODEL, SAVE_POWER_OFF, SAVE_MODEL_PINS, SAVE_STIMULUS, UPDATE_ALL_CONTENT, UPDATE_SIGNAL_GROUP, UPDATE_EXPANDED_GROUP, EDIT_COMPONENT_TABLE, UPDATE_COMPLIANCE, UPDATE_IS_EDITING,UPDATE_PINS_EXPANDED_GROUP,EDIT_SAME_TYPE_COMPONENT_PIN_TABLE
} from './actionType';

export const getD2DChannelInfo = (channelId) => ({
  type: GET_CHANNEL_INFO,
  channelId
})

export const updateD2DChannelInfo = (obj) => ({
  type: UPDATE_CHANNEL_INFO,
  obj
})

export const createInterfaceInfo = (dataList, auroraJson, interfaceName) => ({
  type: CREATE_INTERFACE_INFO,
  dataList,
  auroraJson,
  interfaceName
})

export const saveD2DExtractionInfo = (obj) => ({
  type: SAVE_EXTRACTION_INFO,
  obj
})

export const saveD2DChannelPortSetups = (data, ComponentSetups, contentKey) => ({
  type: SAVE_PORT_SETUPS,
  data,
  ComponentSetups,
  contentKey
});

export const saveD2DReferenceNets = (newReferenceNets, contentKey) => ({
  type: SAVE_REFERENCE_NETS,
  newReferenceNets,
  contentKey
})

export const updateD2DSignalName = (record, prevRecord, contentKey, expandedRowKeys) => ({
  type: UPDATE_SIGNAL_NAME,
  record,
  prevRecord,
  contentKey,
  expandedRowKeys
})

export const updateD2DSignalGroup = (record, prevRecord, contentKey, expandedRowKeys) => ({
  type: UPDATE_SIGNAL_GROUP,
  record,
  prevRecord,
  contentKey,
  expandedRowKeys
})

export const updateD2DSignalNets = (obj) => ({
  type: UPDATE_SIGNAL_NETS,
  obj
})

export const editD2DComponentPinUsage = (record, pcbType, usageCompGroupApply, usageOppositeDirApply) => ({
  type: EDIT_COMPONENT_PIN_TABLE,
  record,
  pcbType,
  usageCompGroupApply,
  usageOppositeDirApply
})

/* === Pin table === */
export const saveModel = ({ record, model, deviceVcc, pinModelsInfo, applyAll, applyAllMemory, pinsModelList }) => ({
  type: SAVE_PIN_MODEL,
  record,
  model,
  deviceVcc,
  pinModelsInfo,
  applyAll,
  applyAllMemory,
  pinsModelList
});

export const savePowerOff = (record, powerOff, applyAll) => ({
  type: SAVE_POWER_OFF,
  record,
  powerOff,
  applyAll
});

export const saveModelPins = ({ record, pinModels, applyAll, modifyType }) => ({
  type: SAVE_MODEL_PINS,
  record,
  pinModels,
  applyAll,
  modifyType
});

export const savePinStimulusModel = ({ record, stimulus, pinName, applyAll }) => ({
  type: SAVE_STIMULUS,
  record,
  stimulus,
  pinName,
  applyAll
});



export const updateD2DStatus = (key, status) => ({
  type: UPDATE_STATUS,
  key,
  status
})

export const updateD2DLoading = (key, loading) => ({
  type: UPDATE_LOADING,
  key,
  loading
})

export const deleteSignalNet = (record, expandedRowKeys) => ({
  type: DELETE_SIGNAL_NET,
  record,
  expandedRowKeys
})

export const addSignalNet = (expandedRowKeys) => ({
  type: ADD_SIGNAL_NET,
  expandedRowKeys
})

export const d2dConfigOperation = ({ verificationId, operationType, projectId, config, id }) => ({
  type: CONFIG_OPERATION,
  verificationId,
  operationType,
  projectId,
  config,
  id
})

export const updateAllContent = ({ id, content, isImmediatelyUpdate }) => ({
  type: UPDATE_ALL_CONTENT,
  id,
  content,
  isImmediatelyUpdate
})

export const updateExpandedGroup = (expandedGroupKeys) => ({
  type: UPDATE_EXPANDED_GROUP,
  expandedGroupKeys
});

export const editD2DComponentTable = (record, pcbType) => ({
  type: EDIT_COMPONENT_TABLE,
  record,
  pcbType,
});

export const updateCompliance = () => ({
  type: UPDATE_COMPLIANCE
})

export const updateIsEditing = (isEditing) => ({
  type: UPDATE_IS_EDITING,
  isEditing
})

export const updatePinsExpandedGroup = (pinsExpandedGroupKeys) => ({
  type: UPDATE_PINS_EXPANDED_GROUP,
  pinsExpandedGroupKeys
})

export const editSameTypeD2DComponentPinUsage = (usage, pcbType, pins) => ({
  type: EDIT_SAME_TYPE_COMPONENT_PIN_TABLE,
  usage,
  pcbType,
  pins
})